import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.some.js";
import axios from "axios";
import { splitTeacherCourses, joinTeacherCourses } from "@/utils/teacherCourseSeparator";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      searchStr: "",
      teacherList: [],
      // 老师列表
      oriTeacherList: [],
      selectedTeacherIndex: 0,
      // 显示停用或启动按钮
      showDisableButton: true,
      // 停用老师 确认弹窗
      showDeactivateTeacher: false,
      // 删除老师课程按钮
      showDeleteTeacherCourse: [],
      //新增老师 弹窗 相关
      showAddTeacher: false,
      teacherId: 0,
      addOrEditTeacher: "",
      teacherName: "",
      teacherPhone: "",
      phoneValidate: false,
      // 任教科目
      courseOptions: [],
      oriCourseOptions: [],
      colorOptions: ["#ff6086", "#2651ff", "#fd9f02", "#09bd3c", "#007bff"],
      searchCourseStr: "",
      selectedCourses: [],
      coursesStr: "",
      // 增加课程
      showAddCourse: false,
      addCourseName: "",
      // 删除课程按钮
      showDeleteCourse: []
    };
  },
  watch: {
    //监听selectedTeacherIndex变化, 选择老师
    selectedTeacherIndex: {
      handler() {
        if (this.teacherList[this.selectedTeacherIndex].isActive == 1) {
          this.showDisableButton = true;
        } else {
          this.showDisableButton = false;
        }
      }
    }
  },
  async mounted() {
    console.log("\nEnter page /teacherAndCourse");

    //获取老师列表
    await this.getTeacherList();
    //获取课程清单
    await this.getCourseOptions();
  },
  methods: {
    //获取老师列表
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr, this.oriCourseOptions);
            // 空字符串，split后会是[""], 需要改成空数组
            if (this.teacherList[i].coursesStr == "") {
              this.teacherList[i].courses = [];
            }

            // 构造老师的科目 删除按钮 显示数组
            this.showDeleteTeacherCourse.push([]);
            for (let j in this.teacherList[i].courses) {
              this.showDeleteTeacherCourse[i].push(false);
            }
          }
          console.log("获取老师列表:", this.teacherList);
          this.oriTeacherList = JSON.parse(JSON.stringify(this.teacherList));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 获取课程清单
    async getCourseOptions() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/queryCourses", params);
        if (resp1.data.code == "0000") {
          if (resp1.data.data) {
            this.courseOptions = JSON.parse(resp1.data.data[0].courses);
            this.oriCourseOptions = JSON.parse(resp1.data.data[0].courses);
            const courseColor = JSON.parse(resp1.data.data[0].courseColor) || {};
            if (!this.courseOptions) {
              this.courseOptions = [];
              this.oriCourseOptions = [];
            }

            // 科目管理修改后同步更新排课页共用的会话缓存。
            sessionStorage.setItem("courseOptions", JSON.stringify(this.courseOptions));
            sessionStorage.setItem("courseColor", JSON.stringify(courseColor));
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 搜索 老师或科目
    search() {
      this.teacherList = [];
      for (let teacherIndex in this.oriTeacherList) {
        let teacherName = this.oriTeacherList[teacherIndex].name;
        let coursesStr = this.oriTeacherList[teacherIndex].coursesStr;
        if (teacherName.includes(this.searchStr)) {
          this.teacherList.push(this.oriTeacherList[teacherIndex]);
        }
        if (coursesStr.includes(this.searchStr)) {
          // 防止老师重复
          if (!this.teacherList.includes(this.oriTeacherList[teacherIndex])) {
            this.teacherList.push(this.oriTeacherList[teacherIndex]);
          }
        }
      }
    },
    // 选择老师
    chooseTeacher(index) {
      this.selectedTeacherIndex = index;
    },
    // 移到老师某个科目上，出现删除按钮
    handleTeacherCourseMouseOver(index, index2) {
      this.showDeleteTeacherCourse[index][index2] = true;
    },
    handleTeacherCourseMouseLeave(index, index2) {
      this.showDeleteTeacherCourse[index][index2] = false;
    },
    // 删除老师的科目
    async deleteTeacherCourse(index, index2) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          courseName: this.teacherList[index].courses[index2],
          teacherId: this.teacherList[index].id
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/deleteTeacherCourse", params);
        if (resp1.data.code == "0000") {
          await this.getTeacherList();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //判断能否停用老师
    async deactivateTeacher() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let teacherId = this.teacherList[this.selectedTeacherIndex].id;
        let params = {
          teacherId: teacherId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/ifCanDeactivateTeacher", params);
        if (resp1.data.code == "0000") {
          //如果可以停用，直接调用
          if (resp1.data.data == 1) {
            await this.confirmDeactivateTeacher();
          }
          //如果不可以停用，提示 弹窗
          if (resp1.data.data == 0) {
            this.showDeactivateTeacher = true;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //停用老师
    async confirmDeactivateTeacher() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let teacherId = this.teacherList[this.selectedTeacherIndex].id;
        let params = {
          teacherId: teacherId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/deactivateTeacher", params);
        if (resp1.data.code == "0000") {
          // 更新状态为停用
          this.teacherList[this.selectedTeacherIndex].isActive = 0;
          this.showDisableButton = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    cancelDeactivateTeacher() {
      this.showDeactivateTeacher = false;
    },
    // 启用老师
    async activateTeacher() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let teacherId = this.teacherList[this.selectedTeacherIndex].id;
      try {
        let params = {
          teacherId: teacherId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/activateTeacher", params);
        if (resp1.data.code == "0000") {
          // 更新状态为启用
          this.teacherList[this.selectedTeacherIndex].isActive = 1;
          this.showDisableButton = true;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //////////
    // 新增老师弹窗相关函数
    addTeacher() {
      this.addOrEditTeacher = "";
      this.searchCourseStr = "";
      this.courseOptions = JSON.parse(JSON.stringify(this.oriCourseOptions));
      this.teacherId = 0;
      this.teacherName = "";
      this.teacherPhone = "";
      this.selectedCourses = [];
      this.coursesStr = "";
      this.showAddTeacher = true;
    },
    // 新增老师
    async saveTeacher() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.validatePhone();
      if (!this.phoneValidate) {
        alert("请输入正确的手机号");
        loading.close();
        return;
      }
      try {
        if (this.teacherName && this.teacherPhone && this.coursesStr) {
          let params = {
            flag: this.addOrEditTeacher,
            teacherId: this.teacherId,
            institution: this.institution,
            teacherName: this.teacherName,
            teacherPhone: this.teacherPhone,
            coursesStr: this.coursesStr
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/addTeacher", params);
          if (resp1.data.code == "0000") {
            await this.getTeacherList();
            this.searchStr = "";
            this.showAddTeacher = false; // 关闭弹窗
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } else {
          alert("请填写完整的老师信息");
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    cancelShowAddTeacher() {
      this.showAddTeacher = false; // 关闭弹窗

      this.teacherName = "";
      this.teacherPhone = "";
      this.selectedCourses = [];
      this.coursesStr = "";
    },
    //修改老师信息
    modifyTeacher() {
      this.addOrEditTeacher = "edit";
      this.teacherId = this.teacherList[this.selectedTeacherIndex].id;
      this.teacherName = this.teacherList[this.selectedTeacherIndex].name;
      this.teacherPhone = this.teacherList[this.selectedTeacherIndex].phone;
      this.searchCourseStr = "";
      this.courseOptions = JSON.parse(JSON.stringify(this.oriCourseOptions));

      //选中的各个课程的数组
      this.selectedCourses = splitTeacherCourses(this.teacherList[this.selectedTeacherIndex].coursesStr, this.oriCourseOptions);
      this.coursesStr = joinTeacherCourses(this.selectedCourses);
      this.showAddTeacher = true;
    },
    // 校验手机号
    validatePhone() {
      const phone = this.teacherPhone;

      // 手机号正则表达式 (11位数字，以1开头, 第二个必须是3-9，剩下9个数字)
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!mobileRegex.test(phone)) {
        this.phoneValidate = false;
        alert("请输入正确的手机号");
        return false;
      }
      this.phoneValidate = true;
      return true;
    },
    // 搜索科目
    searchCourse() {
      console.log("this.searchCourseStr:", this.searchCourseStr);
      this.courseOptions = this.oriCourseOptions.filter(course => course.toLowerCase().includes(this.searchCourseStr.toLowerCase()));
    },
    // 点击科目, 选择 或 取消选中科目
    clickCourse(index) {
      let courseName = this.courseOptions[index];
      const courseIndex = this.selectedCourses.indexOf(courseName);
      if (courseIndex > -1) {
        // 如果课程已被选中，则取消选择
        this.selectedCourses.splice(courseIndex, 1);
      } else {
        // 如果课程未被选中，则添加到选中列表
        this.selectedCourses.push(courseName);
      }
      this.coursesStr = joinTeacherCourses(this.selectedCourses);
      console.log("this.coursesStr:", this.coursesStr);
    },
    //增加科目
    addCourse() {
      this.showAddCourse = true;
    },
    async addCourseConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        const courseName = String(this.addCourseName || "").trim();
        if (this.oriCourseOptions.some(course => String(course).trim() === courseName)) {
          alert("科目名已存在");
          return;
        } else {
          if (!courseName) {
            alert("请输入科目名称");
            return;
          }
          try {
            let params = {
              courseName,
              colorOptions: this.colorOptions,
              institution: this.institution
            };
            let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/addCourse", params);
            if (resp1.data.code == "0000") {
              // this.courseOptions.push(this.addCourseName);
              await this.getCourseOptions();
              this.addCourseName = "";
              this.searchCourse();
              this.showAddCourse = false;
            } else {
              console.log("调用后端出错:", resp1.data.msg);
              alert("调用后端出错: " + resp1.data.msg);
            }
          } catch (error) {
            console.log("catch error:", error);
            alert("catch error");
          }
        }
      } finally {
        loading.close();
      }
    },
    addCourseCancel() {
      this.showAddCourse = false;
    },
    // 移到课程上，出现删除按钮
    handleCourseMouseOver(index) {
      this.showDeleteCourse[index] = true;
    },
    handleCourseMouseLeave(index) {
      this.showDeleteCourse[index] = false;
    },
    // 删除科目
    async deleteCourse(index) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          courseName: this.courseOptions[index],
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/deleteCourse", params);
        if (resp1.data.code == "0000") {
          await this.getCourseOptions();
          this.searchCourse();
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    }
  }
};